import React from 'react';
import '../trucks/style.css';

const Trucks = () => {
  return (
    <>
    <aside className='image_slider'></aside>
    </>
  )
}

export default Trucks